module.exports = __webpack_public_path__ + "static/kubernetes-9e7d0e8e3a2063dba9bb79ddb8cfe98c.svg";